import styled from 'styled-components';
import {useCallback, useMemo} from "react";

const Select = styled.select`
    width: 100%;
    padding: 0.5rem;
    font-size: 1rem;
    border-radius: 0.25rem;
    border: 1px solid #ccc;
`;

export const TaxonomyTreeFilterUI = ({options = [], value = {}, onChange}) => {
    const {
        macrofamilyId,
        familyId,
        subfamilyIds = new Set()
    } = useMemo(() => value, [value]);

    const onChangeMacrofamily = useCallback((event) => {
        const newMacrofamilyId = Number(event.target.value);
        if (!newMacrofamilyId) {
            onChange({});
            return;
        }

        onChange({
            macrofamilyId: newMacrofamilyId,
            familyId: null,
            subfamilyIds: new Set()
        });
    }, []);

    const onChangeFamily = useCallback((familyIdStr) => {
        const id = familyIdStr ? Number(familyIdStr) : null;
        onChange({
            macrofamilyId,
            familyId: id,
            subfamilyIds: new Set()
        });
    }, [macrofamilyId]);

    const onChangeSubfamily = useCallback((event) => {
        const subfamilyId = Number(event.target.value);
        const checked = event.target.checked;

        const updated = new Set(subfamilyIds);
        if (checked) {
            updated.add(subfamilyId);
        } else {
            updated.delete(subfamilyId);
        }

        onChange({
            macrofamilyId,
            familyId,
            subfamilyIds: updated
        });
    }, [macrofamilyId, familyId, subfamilyIds]);

    const families = useMemo(() => {
        return options.find(m => m.id === macrofamilyId)?.familias || [];
    }, [options, macrofamilyId]);

    return (
        <div className="categories-tree">
            <Select value={macrofamilyId || ''} onChange={onChangeMacrofamily}>
                <option value="">Todas las categorías</option>
                {options.map(macro => (
                    <option key={macro.id} value={macro.id}>
                        {macro.macrofamilia}
                    </option>
                ))}
            </Select>

            {macrofamilyId && (
                <div className="mt-2 my-1">
                    <div className="form-check">
                        <input
                            className="form-check-input"
                            type="radio"
                            checked={!familyId}
                            onChange={() => onChangeFamily(null)}
                        />
                        <label className="form-check-label">
                            <small>Todos</small>
                        </label>
                    </div>

                    {families.map(family => (
                        <div key={family.id}>
                            <div className="d-flex flex-row align-items-center gap-1">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    value={family.id}
                                    checked={familyId === family.id}
                                    onChange={event => onChangeFamily(event.target.value)}
                                />
                                <label className="form-check-label">
                                    <small>{family.familia}</small>
                                </label>
                            </div>

                            {familyId === family.id && family.subfamilias.map(subfamily => (
                                <div key={subfamily.id} className="ms-3 form-check">
                                    <input
                                        type="checkbox"
                                        className="form-check-input"
                                        value={subfamily.id}
                                        checked={subfamilyIds.has(subfamily.id)}
                                        onChange={onChangeSubfamily}
                                    />
                                    <label className="form-check-label">
                                        <small>{subfamily.subfamilia}</small>
                                    </label>
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};
